export const getMenuAlignment = (align) => {
    switch (align) {
        case 'end':
            return 'bottom-end';
        case 'center':
            return 'bottom';
        default:
            return 'bottom-start';
    }
};
